////////LIBRARY/////////
import ActionsTypes from '../../constants/ActionsTypes'

const columns = {
	setColumns: (col) => ({
		type: ActionsTypes.SET_COLUMNS,
		payload: {
			col,
		},
	}),
	setTableHeight: (height) => ({
		type: ActionsTypes.SET_TABLE_HEIGHT,
		payload: {
			height,
		},
	}),
	setIsValidateEnable: () => ({
		type: ActionsTypes.SET_IS_VALIDATE_ENABLE,
	}),
	setIsEditingTrigger: () => ({
		type: ActionsTypes.SET_IS_EDITING_TRIGGER,
	}),

	setIsEditingNotTrigger: () => ({
		type: ActionsTypes.SET_IS_EDITING_NOT_TRIGGER,
	}),
	setIsResetForm: () => ({
		type: ActionsTypes.SET_IS_RESET_FORM,
	}),
	setFormButtonWidth: (value) => ({
		type: ActionsTypes.SET_FORM_BUTTON_WIDTH,
		payload: {
			value,
		},
	}),
	setIsSingleEdit: (bool) => ({
		type: ActionsTypes.SET_IS_SINGLE_EDIT,
		payload: {
			bool,
		},
	}),
	setIsSearchfieldUpdated: (bool) => ({
		type: ActionsTypes.SET_IS_SEARCHFIELD_UPDATED,
		payload: {
			bool,
		},
	}),
	setCurrentColumn: (value) => ({
		type: ActionsTypes.SET_CURRENT_COLUMN,
		payload: {
			value,
		},
	}),
	setCurrentDir: (value) => ({
		type: ActionsTypes.SET_CURRENT_DIR,
		payload: {
			value,
		},
	}),
}

export default columns
